/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAnchor = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2a4 4 0 0 1 1 7.874l.001 10.064a8.005 8.005 0 0 0 6.906-6.712l.03-.226H18v-2h4v1c0 5.523-4.477 10-10 10-5.429 0-9.848-4.327-9.996-9.72L2 12v-1h4v2H4.062l.031.226a8.005 8.005 0 0 0 6.908 6.712V9.874A4.001 4.001 0 0 1 12 2zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgAnchor as Anchor };
